(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-cellcore"]) return;
  try {
    
class CartNote extends HTMLElement {
constructor() {
super();

this.addEventListener('change', window.debounce((event) => {
const body = JSON.stringify({ note: event.target.value });
fetch(`${routes.cart_update_url}`, {...window.fetchConfig(), ...{ body }});
}, 300))
}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', window.debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...window.fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-content"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-with-sidebar"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav"]) return;
  try {
    
class CellcoreNav extends HTMLElement {
    connectedCallback() {
      this.relocateThemeBlocks();
      this.drawer = this.querySelector('[data-nav-drawer]');
      this.overlay = this.querySelector('[data-nav-overlay]');
      this.openBtn = this.querySelector('[data-nav-open]');
      this.closeBtns = this.querySelectorAll('[data-nav-close]');
      this.panels = this.querySelectorAll('[data-mobile-panel]');
      this.megaTriggers = this.querySelectorAll('[data-mega-trigger]');
      this.megas = this.querySelectorAll('[data-mega]');
      this.megaWrap = this.querySelector('.cc-nav__mega-wrap');
      this.submenuTriggers = this.querySelectorAll('[data-submenu-trigger]');
      this.mobileNavTriggers = this.querySelectorAll('[data-mobile-nav]');
      this.backBtns = this.querySelectorAll('[data-mobile-back]');
      this.stickyWrap = this.closest('.cc-nav-sticky');

      this.activeMega = null;
      this.activePanel = 'main';
      this.closeTimer = null;

      this.bindEvents();
      this.bindNavCartCount();
      this.initSearchClear();
      this.initFeatureSliders();
      this.bindEditorSelection();
      this.onNavResize = () => {
        window.cancelAnimationFrame(this.navFitFrame);
        this.navFitFrame = window.requestAnimationFrame(() => this.syncNavFit());
      };
      window.addEventListener('resize', this.onNavResize);
      this.syncNavFit();
      document.fonts?.ready?.then(() => {
        if (this.isConnected) this.syncNavFit();
      });
    }

    disconnectedCallback() {
      this.navCartObserver?.disconnect();
      document.removeEventListener('cellcore:cart-updated', this.onNavCartUpdated);
      window.removeEventListener('resize', this.onNavResize);
      window.cancelAnimationFrame(this.navFitFrame);
      this.setMenuLayer(false);
      this.querySelectorAll('[data-nav-slider]').forEach((slider) => {
        window.clearInterval(slider.navSlideTimer);
      });
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    normalizeBlockNode(node) {
      if (!node.classList.contains('shopify-block') || !node.firstElementChild) return node;
      const inner = node.firstElementChild;
      const editorId = node.getAttribute('data-shopify-editor-block');
      if (editorId && !inner.hasAttribute('data-shopify-editor-block')) {
        inner.setAttribute('data-shopify-editor-block', editorId);
      }
      node.replaceWith(inner);
      return inner;
    }

    mountFeatureCards(slot, cards) {
      if (cards.length === 1) {
        slot.appendChild(cards[0]);
        return;
      }

      if (cards.length === 3) {
        const trio = document.createElement('div');
        trio.className = 'cc-nav__feature-cards cc-nav__feature-cards--trio';
        trio.appendChild(cards[0]);
        const stack = document.createElement('div');
        stack.className = 'cc-nav__feature-cards-stack';
        cards.slice(1).forEach((card) => stack.appendChild(card));
        trio.appendChild(stack);
        slot.appendChild(trio);
        return;
      }

      const row = document.createElement('div');
      row.className = 'cc-nav__feature-cards';
      cards.forEach((card) => row.appendChild(card));
      slot.appendChild(row);
    }

    placeNavChildren(entry) {
      const source = entry.querySelector(':scope > [data-nav-child-source]');
      if (!source) return;

      const cards = [];
      const ctas = [];
      [...source.children].forEach((node) => {
        if (node.hasAttribute('hidden')) return;
        const el = this.normalizeBlockNode(node);
        if (el.hasAttribute('hidden')) return;
        if (el.classList.contains('cc-nav__feature-slider')) {
          if (!this.featureSlides(el).length) return;
          cards.push(el);
        } else if (el.classList.contains('cc-nav__feature-card')) cards.push(el);
        else if (el.classList.contains('cc-nav__mega-cta')) ctas.push(el);
      });

      const mega = entry.querySelector(':scope > .cc-nav__mega');
      if (mega) {
        mega.dataset.featureCount = String(cards.length);
        const ctaSlot = mega.querySelector('[data-nav-cta-slot]');
        const featureSlot = mega.querySelector('[data-nav-feature-slot]');
        if (ctaSlot && ctas.length) {
          ctaSlot.hidden = false;
          ctas.forEach((cta) => ctaSlot.appendChild(cta));
        }
        if (featureSlot && cards.length) {
          featureSlot.hidden = false;
          this.mountFeatureCards(featureSlot, cards);
        }
      }

      const mobileSlot = entry.querySelector('[data-nav-cta-slot-mobile]');
      if (mobileSlot && ctas.length) {
        mobileSlot.hidden = false;
        ctas.forEach((cta) => {
          const clone = cta.cloneNode(true);
          [...clone.attributes].forEach((attr) => {
            if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
          });
          mobileSlot.appendChild(clone);
        });
      }
    }

    relocateThemeBlocks() {
      if (this.dataset.navReady === 'true') return;

      const megaWrap = this.querySelector('.cc-nav__mega-wrap');
      const mainItems = this.querySelector('[data-mobile-main-items]');
      const actionItems = this.querySelector('[data-mobile-action-items]');
      const panels = this.querySelector('[data-mobile-panels]');
      const actions = this.querySelector('.cc-nav__actions');
      const actionsMarker = this.querySelector('[data-nav-actions-marker]');

      this.querySelectorAll('[data-nav-entry]').forEach((entry) => {
        if (entry.hasAttribute('hidden')) return;
        this.placeNavChildren(entry);

        const mega = entry.querySelector(':scope > .cc-nav__mega');
        if (mega && megaWrap) megaWrap.appendChild(mega);

        const mobileItem = entry.querySelector(':scope > [data-mobile-entry]');
        const panel = entry.querySelector(':scope > [data-mobile-panel]');
        const placement = entry.dataset.placement || 'nav';

        if (mobileItem) {
          if (placement === 'actions') actionItems?.appendChild(mobileItem);
          else mainItems?.appendChild(mobileItem);
        }
        if (panel && panels) panels.appendChild(panel);

        if (placement === 'actions' && actions && actionsMarker) {
          actions.insertBefore(entry, actionsMarker);
        }
      });

      this.dataset.navReady = 'true';
    }

    featureSlides(slider) {
      [...slider.children].forEach((node) => {
        if (node.classList && node.classList.contains('shopify-block')) this.normalizeBlockNode(node);
      });
      return [...slider.querySelectorAll(':scope > .cc-nav__feature-card')].filter((slide) => !slide.hasAttribute('hidden'));
    }

    showFeatureSlide(slider, slide) {
      const slides = this.featureSlides(slider);
      if (!slides.length) return;
      const next = slides.includes(slide) ? slide : slides[0];
      slides.forEach((item) => {
        const active = item === next;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) item.removeAttribute('tabindex');
        else item.setAttribute('tabindex', '-1');
      });
      slider.classList.add('is-ready');
      slider.dataset.slideIndex = String(slides.indexOf(next));
    }

    initFeatureSliders() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const designMode = window.Shopify && window.Shopify.designMode;

      this.querySelectorAll('[data-nav-slider]').forEach((slider) => {
        if (slider.dataset.sliderReady === 'true') return;
        const slides = this.featureSlides(slider);
        if (!slides.length) {
          slider.hidden = true;
          return;
        }
        slider.dataset.sliderReady = 'true';
        this.showFeatureSlide(slider, slides[0]);
        if (slides.length < 2 || reduceMotion || designMode) return;

        const play = () => {
          window.clearInterval(slider.navSlideTimer);
          slider.navSlideTimer = window.setInterval(() => {
            const current = this.featureSlides(slider);
            const index = Number(slider.dataset.slideIndex) || 0;
            this.showFeatureSlide(slider, current[(index + 1) % current.length]);
          }, 5000);
        };

        play();
        slider.addEventListener('mouseenter', () => window.clearInterval(slider.navSlideTimer));
        slider.addEventListener('mouseleave', play);
        slider.addEventListener('focusin', () => window.clearInterval(slider.navSlideTimer));
        slider.addEventListener('focusout', play);
      });
    }

    bindEditorSelection() {
      if (!window.Shopify || !window.Shopify.designMode) return;
      this.onBlockSelect = (event) => {
        if (!this.isConnected || !this.contains(event.target)) return;
        const mega = event.target.closest('.cc-nav__mega');
        const entry = event.target.closest('[data-nav-entry]');
        const slide = event.target.closest('.cc-nav__feature-slide');
        const slider = slide?.closest('[data-nav-slider]');
        if (slider && slide) this.showFeatureSlide(slider, slide);
        const megaId = mega?.dataset.mega || entry?.querySelector('[data-mega-trigger]')?.dataset.megaTrigger;
        if (megaId && this.isDesktopNav()) {
          const trigger = this.querySelector(`[data-mega-trigger="${CSS.escape(megaId)}"]`);
          if (trigger) this.openMega(megaId, trigger);
        }
        if (!this.isDesktopNav()) {
          this.openDrawer();
          const panel = event.target.closest('[data-mobile-panel]');
          if (panel) {
            this.showMobilePanel(panel.dataset.mobilePanel);
          } else if (entry?.dataset.navId && this.querySelector(`[data-mobile-panel="${CSS.escape(entry.dataset.navId)}"]`)) {
            this.showMobilePanel(entry.dataset.navId);
          }
        }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    bindEvents() {
      this.openBtn?.addEventListener('click', () => this.openDrawer());
      this.overlay?.addEventListener('click', () => this.closeDrawer());
      this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.closeDrawer()));

      this.mobileNavTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          const target = trigger.dataset.mobileNav;
          if (!target) return;
          event.preventDefault();
          this.showMobilePanel(target);
        });
      });

      this.backBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.mobileBack || 'main';
          this.showMobilePanel(target);
        });
      });

      this.querySelectorAll('.cc-nav__mega-category, .cc-nav__mobile-grid-item').forEach((row) => {
        const trigger = row.querySelector(':scope > [data-submenu-trigger]');
        if (!trigger) return;
        row.addEventListener('click', (event) => {
          if (event.target.closest('a, [data-submenu-trigger]')) return;
          trigger.click();
        });
      });

      this.submenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          const panelId = trigger.getAttribute('aria-controls');
          const panel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
          if (!panel) return;

          const row = trigger.closest('.cc-nav__mega-category, .cc-nav__mobile-grid-item') || trigger;
          const isDesktopCategory = row.classList.contains('cc-nav__mega-category');

          if (isDesktopCategory && this.isDesktopNav()) {
            event.preventDefault();
            const col = row.closest('.cc-nav__mega-col--categories');
            const isExpanded = row.classList.contains('is-expanded');

            col?.querySelectorAll('.cc-nav__mega-category').forEach((el) => {
              el.classList.remove('is-expanded');
              el.querySelector('[data-submenu-trigger]')?.setAttribute('aria-expanded', 'false');
            });
            col?.querySelectorAll('[data-submenu-panel]').forEach((el) => el.classList.remove('is-open'));

            if (!isExpanded) {
              panel.classList.add('is-open');
              row.classList.add('is-expanded');
              trigger.setAttribute('aria-expanded', 'true');
            }
            return;
          }

          if (!this.isDesktopNav()) {
            event.preventDefault();
            const isOpen = panel.classList.contains('is-open');
            panel.classList.toggle('is-open', !isOpen);
            row.classList.toggle('is-expanded', !isOpen);
            trigger.setAttribute('aria-expanded', String(!isOpen));
          }
        });
      });

      this.megaTriggers.forEach((trigger) => {
        const megaId = trigger.dataset.megaTrigger;
        if (!this.querySelector(`[data-mega="${megaId}"]`)) return;

        trigger.addEventListener('mouseenter', () => {
          if (this.isDesktopNav()) this.openMega(megaId, trigger);
        });
        trigger.addEventListener('focus', () => this.openMega(megaId, trigger));
        trigger.addEventListener('click', (event) => {
          if (!this.isDesktopNav() || this.triggerNavigates(trigger)) return;
          event.preventDefault();
          if (this.activeMega === megaId) {
            this.closeMega();
          } else {
            this.openMega(megaId, trigger);
          }
        });

        trigger.addEventListener('keydown', (event) => {
          if (this.triggerNavigates(trigger) && event.key === 'Enter') return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (this.activeMega === megaId) {
              this.closeMega();
            } else {
              this.openMega(megaId, trigger);
            }
          }
        });
      });

      this.bindDesktopMegaHover();

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeMega();
          this.closeDrawer();
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.closeMega();
        }
      });
    }

    setMenuLayer(isOpen) {
      this.closest('.shopify-section')?.classList.toggle('cc-nav-section--menu-open', isOpen);
      document.body.classList.toggle('cc-nav-menu-open', isOpen);
    }

    openDrawer() {
      this.drawer?.classList.add('is-open');
      this.overlay?.classList.add('is-open');
      this.drawer?.setAttribute('aria-hidden', 'false');
      this.overlay?.setAttribute('aria-hidden', 'false');
      this.openBtn?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      this.setMenuLayer(true);
      this.showMobilePanel('main');
    }

    closeDrawer() {
      this.drawer?.classList.remove('is-open');
      this.overlay?.classList.remove('is-open');
      this.drawer?.setAttribute('aria-hidden', 'true');
      this.overlay?.setAttribute('aria-hidden', 'true');
      this.openBtn?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      this.setMenuLayer(false);
      this.showMobilePanel('main');
    }

    showMobilePanel(panelId) {
      this.activePanel = panelId;
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.mobilePanel === panelId);
      });
    }

    getDesktopBreakpoint() {
      const raw = getComputedStyle(this).getPropertyValue('--cc-nav-desktop-break').trim();
      const parsed = parseInt(raw, 10);
      return Number.isFinite(parsed) ? parsed : 1024;
    }

    isDesktopNav() {
      return window.innerWidth >= this.getDesktopBreakpoint() && !this.classList.contains('cc-nav--force-mobile');
    }

    triggerNavigates(trigger) {
      if (trigger.tagName !== 'A') return false;
      const href = (trigger.getAttribute('href') || '').trim();
      return href !== '' && href !== '#';
    }

    desktopItemWidth(el) {
      const style = getComputedStyle(el);
      const minWidth = parseFloat(style.minWidth);
      if ((parseFloat(style.flexGrow) || 0) > 0 && Number.isFinite(minWidth)) return minWidth;
      return el.getBoundingClientRect().width;
    }

    desktopOverflow() {
      const center = this.querySelector('.cc-nav__inner.cc-nav__desktop-only .cc-nav__center');
      if (!center || getComputedStyle(center).display === 'none') return 0;
      const style = getComputedStyle(center);
      const gap = parseFloat(style.columnGap) || 0;
      const pad = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
      const items = [...center.children].filter((el) => !el.hasAttribute('hidden') && getComputedStyle(el).display !== 'none');
      if (!items.length) return 0;
      const needed = items.reduce((sum, el) => sum + this.desktopItemWidth(el), 0) + gap * Math.max(items.length - 1, 0) + pad;
      return needed - center.clientWidth;
    }

    syncNavFit() {
      const desktopWidth = window.innerWidth >= this.getDesktopBreakpoint();
      if (!desktopWidth) {
        this.classList.remove('cc-nav--force-mobile');
        this.minDesktopViewport = 0;
        return;
      }

      if (this.classList.contains('cc-nav--force-mobile')) {
        if (window.innerWidth < (this.minDesktopViewport || Infinity)) return;
        this.classList.remove('cc-nav--force-mobile');
        this.closeDrawer();
        window.requestAnimationFrame(() => {
          if (this.isConnected) this.syncNavFit();
        });
        return;
      }

      const overflow = this.desktopOverflow();
      if (overflow > -8) {
        this.minDesktopViewport = Math.ceil(window.innerWidth + Math.max(overflow, 0) + 8);
        this.closeMega();
        this.classList.add('cc-nav--force-mobile');
      }
    }

    bindDesktopMegaHover() {
      if (!this.megaWrap) return;

      const hoverTargets = new Set([this.megaWrap]);
      this.megaTriggers.forEach((trigger) => {
        const item = trigger.closest('.cc-nav__item');
        if (item) hoverTargets.add(item);
      });

      hoverTargets.forEach((target) => {
        target.addEventListener('mouseenter', () => {
          if (!this.isDesktopNav()) return;
          window.clearTimeout(this.closeTimer);
        });
        target.addEventListener('mouseleave', () => {
          if (!this.isDesktopNav()) return;
          this.scheduleMegaClose();
        });
      });
    }

    scheduleMegaClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.closeMega(), 250);
    }

    openMega(megaId, trigger) {
      window.clearTimeout(this.closeTimer);
      this.activeMega = megaId;
      this.megas.forEach((mega) => {
        mega.classList.toggle('is-open', mega.dataset.mega === megaId);
      });
      this.megaTriggers.forEach((el) => {
        const isActive = el.dataset.megaTrigger === megaId;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-expanded', String(isActive));
        el.closest('.cc-nav__item')?.classList.toggle('is-open', isActive);
      });
    }

    closeMega() {
      window.clearTimeout(this.closeTimer);
      this.activeMega = null;
      this.megas.forEach((mega) => mega.classList.remove('is-open'));
      this.megaTriggers.forEach((el) => {
        el.classList.remove('is-active');
        el.setAttribute('aria-expanded', 'false');
        el.closest('.cc-nav__item')?.classList.remove('is-open');
      });
    }

    bindNavCartCount() {
      this.onNavCartUpdated = (event) => {
        const count = Number(event.detail?.cart?.item_count);
        if (Number.isFinite(count)) this.paintNavCartCount(count);
      };
      document.addEventListener('cellcore:cart-updated', this.onNavCartUpdated);

      this.navCartObserver = new MutationObserver(() => {
        if (this.syncingNavCart) return;
        this.syncNavCartFromBubbles();
      });

      const watch = () => {
        document.getElementById('cart-icon-bubble') &&
          this.navCartObserver.observe(document.getElementById('cart-icon-bubble'), {
            childList: true,
            subtree: true,
            characterData: true,
          });
        const floatIcon = document.getElementById('cart-icon-float');
        if (floatIcon) {
          this.sawFloatBubble = !!floatIcon.querySelector('.cart-count-bubble');
          this.navCartObserver.observe(floatIcon, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', watch, { once: true });
      } else {
        watch();
      }
    }

    readNavCartBubble(bubble) {
      if (!bubble) return null;
      const visible = bubble.querySelector("[aria-hidden='true']");
      const raw = (visible ? visible.textContent : bubble.textContent).replace('99+', '100').trim();
      if (!raw) return 0;
      const parsed = parseInt(raw, 10);
      return Number.isFinite(parsed) ? parsed : null;
    }

    syncNavCartFromBubbles() {
      const icon = document.getElementById('cart-icon-bubble');
      const injected = icon?.querySelector('.cart-count-bubble:not(.cc-nav__cart-count)');
      const replaced = icon && !icon.querySelector('img') && !!icon.querySelector('svg, .icon-cart');
      const floatBubble = document.querySelector('#cart-icon-float .cart-count-bubble');

      if (injected) {
        this.paintNavCartCount(this.readNavCartBubble(injected) || 0);
        return;
      }
      if (replaced) {
        this.paintNavCartCount(this.readNavCartBubble(icon.querySelector('.cart-count-bubble')) || 0);
        return;
      }
      if (floatBubble) {
        this.sawFloatBubble = true;
        this.paintNavCartCount(this.readNavCartBubble(floatBubble) || 0);
        return;
      }
      if (this.sawFloatBubble) {
        this.sawFloatBubble = false;
        this.paintNavCartCount(0);
      }
    }

    paintNavCartCount(count) {
      this.syncingNavCart = true;
      const display = count > 99 ? '99+' : String(count);
      this.querySelectorAll('a.cc-nav__cart').forEach((icon) => {
        const donor = this.querySelector('a.cc-nav__cart img');
        if (!icon.querySelector('img') && donor) {
          const label = icon.querySelector('.visually-hidden')?.textContent || 'Cart';
          icon.replaceChildren(donor.cloneNode(true));
          const hidden = document.createElement('span');
          hidden.className = 'visually-hidden';
          hidden.textContent = label;
          icon.appendChild(hidden);
        }
        icon.querySelectorAll('.cart-count-bubble:not(.cc-nav__cart-count)').forEach((node) => node.remove());

        let badge = icon.querySelector('.cc-nav__cart-count');
        let announcement = icon.querySelector('[data-nav-cart-count]');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cc-nav__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            icon.appendChild(badge);
          }
          badge.textContent = display;
          if (!announcement) {
            announcement = document.createElement('span');
            announcement.className = 'visually-hidden';
            announcement.setAttribute('data-nav-cart-count', '');
            icon.appendChild(announcement);
          }
          announcement.textContent = count === 1 ? '1 item' : `${display} items`;
        } else {
          badge?.remove();
          announcement?.remove();
        }
      });
      this.navCartHasCount = count > 0;
      window.setTimeout(() => {
        this.syncingNavCart = false;
      }, 0);
    }

    initSearchClear() {
      this.querySelectorAll('[data-cc-nav-search-clear]').forEach((btn) => {
        const form = btn.closest('form');
        const input = form?.querySelector('.cc-nav__search-input');
        const predictiveSearch = btn.closest('predictive-search');
        if (!input) return;

        const syncClear = () => {
          const hasValue = !!input.value.length;
          btn.hidden = !hasValue;
          btn.classList.toggle('is-visible', hasValue);
        };

        input.addEventListener('input', syncClear);
        input.addEventListener('focus', syncClear);
        syncClear();

        btn.addEventListener('click', (event) => {
          event.preventDefault();
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
          syncClear();
          if (predictiveSearch && typeof predictiveSearch.close === 'function') {
            predictiveSearch.close(false);
          }
        });
      });
    }
  }

  if (!customElements.get('cellcore-nav')) {
    customElements.define('cellcore-nav', CellcoreNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
